export enum TemporalityEnum {
  CHRONIC,
  ACUTE,
  ONESHOT,
}

export const mapStringToTemporality = (
  temporality?: string
): TemporalityEnum => {
  switch (temporality && temporality.toUpperCase()) {
    case "ACUTE":
      return TemporalityEnum.ACUTE;
    case "CHRONIC":
      return TemporalityEnum.CHRONIC;
    case "ONESHOT":
      return TemporalityEnum.ONESHOT;
    default:
      return TemporalityEnum.ACUTE;
  }
};

export const translateKey = (value: string): string => {
  return "temporality." + value.toLowerCase();
};

export const selectableTemporalityTypes = () => {
  return [
    TemporalityEnum.CHRONIC,
    TemporalityEnum.ACUTE,
    TemporalityEnum.ONESHOT,
  ];
};
